export { default } from './ErrorPage';
